export default ['Upper Body', 'Legs', 'Shoulders'];